import { Box } from "@chakra-ui/react";
import { HttpMethod } from "./types";
import { METHOD_COLORS } from "./helpers";

export function MethodBadge({ method }: { method: HttpMethod }) {
  const { bg, color } = METHOD_COLORS[method];
  return (
    <Box
      as="span"
      bg={bg}
      color={color}
      fontSize="11px"
      fontWeight="700"
      px="10px"
      py="3px"
      borderRadius="10px"
      minW="52px"
      textAlign="center"
      letterSpacing="0.5px"
      flexShrink={0}
    >
      {method}
    </Box>
  );
}
